import {useTranslation} from 'react-i18next';
import ICON_UNCHECK_LIGHT from '../../../public/static/icon-radio-off-light.svg';
import ICON_UNCHECK from '../../../public/static/icon-radio-off.svg';
import ICON_CHECK_LIGHT from '../../../public/static/icon-radio-on-light.svg';
import ICON_CHECK from '../../../public/static/icon-radio-on.svg';
import CheckBoxV4 from '../../common/component/CheckBoxV4';
import TextButton from '../../common/component/TextButton';
import {WEB_HOST} from '../../common/constant';
import {Page} from '../../common/constant/page';
import {openWindow} from '../../common/function';
import useTheme from '../../common/hook/useTheme';
import useCommentEvent from '../hook/useCommentEvent';
import {ReportType} from '../type';

interface IProps {
  type: ReportType;
  isSelected: boolean;
  commentId: number;
  className?: string;
  onChange: (type: ReportType) => void;
}

export default function ReportItem({
  type,
  isSelected,
  commentId,
  className,
  onChange,
}: IProps) {
  const {t} = useTranslation();
  const {isLightMode} = useTheme();

  const {sendCommentEvent} = useCommentEvent('comments_report');
  const onClickRightReportInfo = () => {
    openWindow({
      url: `${WEB_HOST}/${Page.MoreRightReport}`,
      windowName: '',
    });
    sendCommentEvent({
      actionName: 'report_rights',
      action: 'click',
      customProps: {comment_id: commentId},
    });
  };

  return (
    <li className={className ?? 'mb-26'}>
      <div className="flex justify-between">
        <CheckBoxV4
          id={type}
          imgChecked={isLightMode ? ICON_CHECK_LIGHT : ICON_CHECK}
          imgUnchecked={isLightMode ? ICON_UNCHECK_LIGHT : ICON_UNCHECK}
          imgWidth={18}
          label={t(ReportTypeTextKey[type])}
          labelClassName="s14-medium-white light:text-black"
          checked={isSelected}
          onChange={() => onChange(type)}
          additionalElement={
            type === ReportType.Right && (
              <TextButton
                className="h-full ml-6 flex-center btn-transparent !p-0"
                textClassName="s12-regular-grey08 underline"
                onClick={onClickRightReportInfo}
              >
                {t('comment_report_file_button')}
              </TextButton>
            )
          }
        />
      </div>
    </li>
  );
}

const ReportTypeTextKey: {[key in ReportType]: string} = {
  [ReportType.Spam]: 'comment_report_spam',
  [ReportType.Illegal]: 'comment_report_illegal',
  [ReportType.Sexual]: 'comment_report_sexual',
  [ReportType.Violence]: 'comment_report_violence',
  [ReportType.Privacy]: 'comment_report_privacy',
  [ReportType.Repeatedly]: 'comment_report_repeatedly',
  [ReportType.Etc]: 'comment_report_other',
  [ReportType.Right]: 'comment_report_rights',
  [ReportType.Piracy]: 'comment_report_piracy',
};
